import { render, staticRenderFns } from "./KeywordsDialog.vue?vue&type=template&id=10aa090a&scoped=true&"
import script from "./KeywordsDialog.vue?vue&type=script&lang=js&"
export * from "./KeywordsDialog.vue?vue&type=script&lang=js&"
import style0 from "./KeywordsDialog.vue?vue&type=style&index=0&id=10aa090a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aa090a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VCheckbox,VList,VListItem,VListItemAction,VListItemContent,VListItemTitle,VRadio,VRadioGroup,VTextField,VVirtualScroll})
